import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n/i18n";
import { auth } from "./firebase";
import vuetifyConfirm from "vuetify-confirm";
// see https://github.com/vuetifyjs/vuetify/issues/12224#issuecomment-703061437
//import Ripple from 'vuetify/lib/directives/ripple';

Vue.config.productionTip = false;
Vue.use(vuetifyConfirm, {vuetify});

let app;
auth.onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      router,
      created() {
        setInterval(() => { store.dispatch('saveProject') }, 60000);
        let browserLocale = navigator.languages[0].substring(0, navigator.languages[0].indexOf("-"));
        this.$store.dispatch('setLocale', browserLocale);
      },
      store,
      vuetify,
      vuetifyConfirm,
      i18n,
      render: (h) => h(App)
    }).$mount("#app");
  }

  if (user) {
    store.commit('setAuthenticated', user != null);
  }
});

export function nameCheck(name, searchSpace) {
  let end = /\s([0-9]+)$/
  
  if(end.test(name)) {
    let found = name.match(new RegExp(/([0-9]+)$/))

    let c = 1 + parseInt(found[0])
    name = name.replace(new RegExp(/([0-9]+)$/), c.toString())
  } else if (searchSpace.includes(name)){
    name = name + " 1"
  }

  if(searchSpace.includes(name)){
    name = nameCheck(name, searchSpace)
  }

  return name
}

export const NUTRIENT_KEYS = ['N','P','K']

// https://www.cluemediator.com/find-urls-in-string-and-make-a-link-using-javascript

export function linkify(message) {
  if(!message) return;
 
  var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
  return message.replace(urlRegex, function (url) {
    var hyperlink = url;
    if (!hyperlink.match('^https?:\\/\\/')) {
      hyperlink = 'http://' + hyperlink;
    }
    return '<a href="' + hyperlink + '" target="_blank" rel="noopener noreferrer">' + url + '</a>'
  });
}